export const requestedPathKey = 'requestedPathOnAutoLogout';

// Java's maximum integer value
export const API_MAX_LIMIT = 2147483647;

const authBaseUri = 'api/identity/auth';

export const authEndpoints = {
  authenticate: `${authBaseUri}/authenticate`,
  codeExchange: `${authBaseUri}/code-exchange`,
  logout: `${authBaseUri}/logout`,
  mfaExchange: `${authBaseUri}/mfa-exchange`,
  mfaResend: `${authBaseUri}/mfa-resend`,
  refreshToken: `${authBaseUri}/refresh`,
  resetPassword: `${authBaseUri}/reset-password`,
};
